import { render, staticRenderFns } from "./select.vue?vue&type=template&id=72cf0026&scoped=true&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"
import style0 from "./select.vue?vue&type=style&index=0&id=72cf0026&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf0026",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72cf0026')) {
      api.createRecord('72cf0026', component.options)
    } else {
      api.reload('72cf0026', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=72cf0026&scoped=true&", function () {
      api.rerender('72cf0026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photoSelect/select.vue"
export default component.exports